import { render } from "./FilterSettings.vue?vue&type=template&id=166fca60"
import script from "./FilterSettings.vue?vue&type=script&lang=js"
export * from "./FilterSettings.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__